module.exports = __webpack_public_path__ + "img/img30.0f3f842c.svg";